import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@ainkauf/core";
import { config, isConfigured } from "./config";

/**
 * Nur diese eine Instanz wird angesprochen (siehe CLAUDE.md, Vorfall vom
 * 12.05.2026 im Schwesterprojekt). Fehlt die Konfiguration, läuft die App
 * rein lokal weiter, statt beim Start zu scheitern.
 */
let client: SupabaseClient<Database> | null = null;

export function supabaseConfigured(): boolean {
  return isConfigured();
}

export function getSupabase(): SupabaseClient<Database> | null {
  if (!supabaseConfigured()) return null;
  const { supabaseUrl, supabaseAnonKey } = config();
  client ??= createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    realtime: { params: { eventsPerSecond: 5 } },
  });
  return client;
}
